import { BuildingOfficeOrderSiteMenuList } from "../../utils/constants";
import { TableStructure } from "../../components/TableStructure";

const List = [
  {
    fileStoreId: "a60ef1e8-1808-439e-8b1a-6cb95a565c61",
    label: "DG(BLDG)'s Office Order No. 18 of 2013-2014",
    date: "31/01/2014",
    subject: "NOC from EKWA",
  },
  {
    fileStoreId: "5859c0bd-fcc1-40b5-aa9c-388a8e99be69",
    label: "DG(BLDG)'s Office Order No. 17 of 2013-2014",
    date: "24/12/2014",
    subject:
      "Owner applicant to inform shortfall regarding proposal us 393, 394, R26",
  },
  {
    fileStoreId: "2cc81ec2-8714-4c86-81e9-5d565cadc3bd",
    label: "DG(BLDG)'s Office Order No. 16 of 2013-2014",
    date: "16/01/2014",
    subject: "Circular 10 of 2013-14 to be kept in abeyance",
  },
  {
    fileStoreId: "cece87a1-4a3d-4f32-9480-4d9831d7d734",
    label: "DG(BLDG)'s Office Order No. 15 of 2013-2014",
    date: "21/11/2013",
    subject: "Online CC through MAS",
  },
  {
    fileStoreId: "229850bc-80af-432e-8b7a-ce6db0974a02",
    label: "DG(BLDG)'s Office Order No. 13 of 2013-2014",
    date: "14/11/2013",
    subject: "Electrical drawing for rule 132",
  },
  {
    fileStoreId: "9da79add-6420-4efc-8cb1-20eb480adeaa",
    label: "DG(BLDG)'s Office Order No. 12 of 2013-2014",
    date: "08/10/2013",
    subject: "Observation of HCC before issuance of CC of Heritage Building",
  },
  {
    fileStoreId: "26de97a5-fbcf-4d01-886c-f433c2e212f6",
    label: "DG(BLDG)'s Office Order No. 05 of 2013-2014",
    date: "20/05/2013",
    subject: "Post facto sanction in Kasba Industrial Extates",
  },
  {
    fileStoreId: "6bc6de5f-44ae-4557-9c38-a6efcedc1864",
    label: "DG(BLDG)'s Office Order No. 04 of 2013-2014",
    date: "20/05/2013",
    subject: "pen space abutting SUTI canal in Ward no 109",
  },
  {
    fileStoreId: "c598f3a1-4998-47f3-9531-48f988a23afe",
    label: "DG(BLDG)'s Office Order No. 03 of 2013-2014",
    date: "24/03/2014",
    subject: "Format to process uc cases us 400",
  },
  {
    fileStoreId: "2eafd732-a254-45a7-ac5d-752ac6f821a4",
    label: "DG(BLDG)'s Office Order No. 03 of 2013-2014",
    date: "17/04/2013",
    subject:
      "Thika sanction plan to sent Borough EE for checking the construction",
  },
  {
    fileStoreId: "4913de4d-50a3-42b0-b094-a776037391b0",
    label: "DG(BLDG)'s Office Order No. 02 of 2013-2014",
    date: "10/04/2013",
    subject: "Joka CC from Zila Parishad",
  },
  {
    fileStoreId: "09dd47ff-897d-4f58-bdfe-11a6636b1240",
    label: "DG(BLDG)'s Office Order No. 01 of 2013-2014",
    date: "02/04/2013",
    subject:
      "Diploma LBS with 5 yrs license can issue structural stability certificate",
  },
  {
    fileStoreId: "d8acf779-e22a-440e-a17b-788ba0288801",
    label: "DG(BLDG)'s Office Order No. 01 of 2013-2014",
    date: "01/04/2013",
    subject: "Barcoded demand notice",
  },
];

const Building_OfficeOreder_2013 = () => (
  <TableStructure
    title="Office Order/ 2013"
    heading={false}
    list={List}
    columnNo={3}
    firstColumnName="Office Order No"
    leftMenuList={BuildingOfficeOrderSiteMenuList}
    longMenuList={true}
  />
);

export default Building_OfficeOreder_2013;
